import { SettingConst } from '../../types';

/**
 * Use for adding emergency stop phone feature by showing phone unavailable indicator to the customer
 */
export const HELP_CENTER_PHONE_EMERGENCY_STOP =
  'HELP_CENTER_PHONE_EMERGENCY_STOP' as SettingConst<
    'HELP_CENTER_PHONE_EMERGENCY_STOP',
    boolean,
    'HELP_CENTER' | 'RETAILER_IOS' | 'RETAILER_ANDROID'
  >;
